// export const API_ENDPOINTS = {
//     AUTH: {
//         LOGIN: '/auth/login',
//         REGISTER: '/auth/register',
//         LOGOUT: '/auth/logout',
//         FORGOT_PASSWORD: '/auth/forgot-password',
//     },
//     SPORTS: {
//         LIST:          '/sports',
//         LIST_ALL:      '/sports/all',
//         CREATE:        '/sports',
//         GET_BY_ID:     (id) => `/sports/${id}`,
//         UPDATE:        (id) => `/sports/${id}`,
//         DELETE:        (id) => `/sports/${id}`,
//         TOGGLE_STATUS: (id) => `/sports/${id}/status`,   // ← add this
//     },
//     // COURTS: {
//     //     LIST: '/courts',
//     //     GET_BY_ID: (id) => `/courts/${id}`,
//     //     AVAILABLE_SLOTS: (id) => `/courts/${id}/slots`,
//     // },
//     COURTS: {
//     // ── Public ──────────────────────────────────────────────────────────────
//     LIST:             '/courts',
//     GET_BY_ID:        (id) => `/courts/${id}`,

//     // ── Vendor / Admin ───────────────────────────────────────────────────────
//     MY_COURTS:        '/courts/my',
//     CREATE:           '/courts',
//     UPDATE:           (id) => `/courts/my/${id}`,
//     DELETE:           (id) => `/courts/my/${id}`,
//     TOGGLE_STATUS:    (id) => `/courts/my/${id}/status`,
//     REGISTRATIONS:    (id) => `/courts/${id}/registrations`,

//     // ── Admin Override ───────────────────────────────────────────────────────
//     ADMIN_STATUS:     (id) => `/courts/${id}/status`,

//     // ── Slots (Separate CourtSlot collection) ────────────────────────────────
//     SLOTS_WEEKLY:     (id) => `/courts/${id}/slots/weekly`,
//     BOOK_SLOT:        (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/book`,
//     UNBOOK_SLOT:      (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/unbook`,

//     // ── Dropdowns ────────────────────────────────────────────────────────────
//     DROPDOWN_SPORTS:  '/courts/dropdown/sports',
//     DROPDOWN_VENDORS: '/courts/dropdown/vendors',
// },
//     TOURNAMENTS: {
//         LIST: '/tournaments',
//         GET_BY_ID: (id) => `/tournaments/${id}`,
//         REGISTER: (id) => `/tournaments/${id}/register`,
//     },
//     COACHES: {
//         LIST: '/coaches',
//         GET_BY_ID: (id) => `/coaches/${id}`,
//         AVAILABLE_SLOTS: (id) => `/coaches/${id}/slots`,
//     },
//     BOOKINGS: {
//         CREATE_COURT: '/bookings/court',
//         CREATE_COACH: '/bookings/coach',
//         MY_COURT_BOOKINGS: '/bookings/my/court',
//         MY_COACH_BOOKINGS: '/bookings/my/coach',
//         GET_BY_ID: (id) => `/bookings/${id}`,
//         CANCEL: (id) => `/bookings/${id}/cancel`,
//     },
//     MATCHES: {
//         LIVE: '/matches/live',
//         MY_MATCHES: (id) => `/tournaments/${id}/my-matches`,
//     },
//     MY_TOURNAMENTS: { LIST: '/my-tournaments' },
//     PROFILE: {
//         GET: '/profile',
//         UPDATE: '/profile',
//         CHANGE_PASSWORD: '/profile/change-password',
//         STATS: '/profile/stats',
//     },
// };
export const API_ENDPOINTS = {
    // Auth — Gateway /login/* → Auth Service :5000
//    AUTH: {
//     LOGIN:           '/login/login',
//     ADMIN_LOGIN:     '/login/admin/login',   // ← this
//     VENDOR_LOGIN:    '/login/vendor-referee/login',
//     LOGOUT:          '/login/logout',
//     REFRESH:         '/login/refresh-token',
//     FORGOT_PASSWORD: '/login/forgot-password',
//     RESET_PASSWORD:  '/login/reset-password',
//     REGISTER:        '/login/register',
//     APPROVE_USER:    (userId) => `/login/approve/${userId}`,
// },
AUTH: {
  LOGIN: '/login/login',
  ADMIN_LOGIN: '/login/admin/login',
  VENDOR_LOGIN: '/login/vendor-referee/login',
  LOGOUT: '/login/logout',
  REFRESH: '/login/refresh-token',
  FORGOT_PASSWORD: '/login/forgot-password',
  RESET_PASSWORD: '/login/reset-password',
  REGISTER: '/login/register',
  APPROVE_USER: (userId) => `/login/approve/${userId}`,

    // Mobile OTP — registration verification
  VERIFY_REGISTRATION_OTP: '/login/verify-registration-otp',
  RESEND_OTP: '/login/resend-otp',

  // Mobile OTP — customer login
  REQUEST_LOGIN_OTP: '/login/login/otp/request',
  VERIFY_LOGIN_OTP: '/login/login/otp/verify',

  ME: '/login/me',
  UPLOAD_AVATAR: '/login/me/avatar',
  UPDATE_PERSONAL: '/login/me/personal',
  UPDATE_ADDRESS: '/login/me/address',
  UPDATE_BANK_DETAILS: '/login/me/bank-details',
  UPDATE_STRENGTHS: '/login/me/strengths',
  CHANGE_PASSWORD: '/login/me/change-password',
},

    // Dashboard
    DASHBOARD: {
        STATS:             '/dashboard/stats',
        USER_DISTRIBUTION: '/dashboard/user-distribution',
        REVENUE_BREAKDOWN: '/dashboard/revenue-breakdown',
        TOURNAMENT_STATUS: '/dashboard/tournament-status',
    },

    // Vendors — Gateway /vendors/* → Vendor Service :5001
    VENDORS: {
        LIST:      '/vendors',
        CREATE:    '/vendors',
        REGISTER: '/vendors/register',
        GET_BY_ID: (id) => `/vendors/${id}`,
        UPDATE:    (id) => `/vendors/${id}`,
        DELETE:    (id) => `/vendors/${id}`,
        STATUS:    (id) => `/vendors/${id}/status`,
    },

    // Tournaments
    // TOURNAMENTS: {
    //     BASE:           '/tournaments',
    //     BY_ID:          (id) => `/tournaments/${id}`,
    //     TOGGLE:         (id) => `/tournaments/${id}/toggle`,
    //     STATS:          '/tournaments/stats',
    //     VENDOR_COURTS:  (vendorId) => `/tournaments/vendor/${vendorId}/courts`,
    // },

    // // ─── Vendor tournament routes ─────────────────────────────────────────────
    // VENDOR: {
    //     TOURNAMENTS: {
    //     BASE:   '/tournaments/vendor/tournaments',
    //     BY_ID:  (id) => `/tournaments/vendor/tournaments/${id}`,
    //     TOGGLE: (id) => `/tournaments/vendor/tournaments/${id}/toggle`,
    //     STATS:  '/tournaments/vendor/tournaments/stats',
    //     },
    //     REGISTRATIONS: {
    //     BASE:   '/tournaments/vendor/registrations',
    //     BY_ID:  (id) => `/tournaments/vendor/registrations/${id}`,
    //     STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
    //     },
    //     MATCHES: {
    //     BASE:   '/tournaments/vendor/matches',
    //     BY_ID:  (id) => `/tournaments/vendor/matches/${id}`,
    //     },
    // },

    // // ─── Admin registration routes ────────────────────────────────────────────
    // REGISTRATIONS: {
    //     BASE:   '/tournaments/registrations',
    //     BY_ID:  (id) => `/tournaments/registrations/${id}`,
    //     STATUS: (id) => `/tournaments/registrations/${id}/status`,
    // },

    // // ─── Admin match routes ───────────────────────────────────────────────────
    // MATCHES: {
    //     BASE:   '/tournaments/matches',
    //     BY_ID:  (id) => `/tournaments/matches/${id}`,
    // },
  //   TOURNAMENTS: {
  //   BASE:          '/tournaments',
  //   BY_ID:         (id)       => `tournaments/${id}`,
  //   TOGGLE:        (id)       => `/tournaments/${id}/toggle`,
  //   STATS:                       '/tournaments/stats',
  //   // Vendor courts for CreateTournament dropdown
  //   VENDOR_COURTS: (vendorId) => `/tournaments/courts/by-vendor/${vendorId}`,
  // },

  // REGISTRATIONS: {
  //   BASE:    '/tournaments/registrations',
  //   BY_ID:   (id) => `/tournaments/registrations/${id}`,
  //   STATUS:  (id) => `/tournaments/registrations/${id}/status`,
  //   APPROVE: (id) => `/tournaments/registrations/${id}/approve`,
  //   REJECT:  (id) => `/tournaments/registrations/${id}/reject`,
  // },

  // MATCHES: {
  //   BASE:  '/tournaments/matches',
  //   BY_ID: (id) => `/tournaments/matches/${id}`,
  // },

  // VENDOR: {
  //   TOURNAMENTS: {
  //     BASE:   '/tournaments/vendor',
  //     BY_ID:  (id) => `/tournaments/vendor/${id}`,
  //     TOGGLE: (id) => `/tournaments/vendor/${id}/toggle`,
  //     STATS:          '/tournaments/vendor/stats',
  //   },
  //   REGISTRATIONS: {
  //     BASE:   '/tournaments/vendor/registrations',
  //     BY_ID:  (id) => `/tournaments/vendor/registrations/${id}`,
  //     STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
  //   },
  //   MATCHES: {
  //     BASE:  '/tournaments/vendor/matches',
  //     BY_ID: (id) => `/tournaments/vendor/matches/${id}`,
  //   },
  // },
  // TOURNAMENTS: {
  //   BASE: '/tournaments',
  //   BY_ID: (id) => `/tournaments/${id}`,
  //   TOGGLE: (id) => `/tournaments/${id}/toggle`,
  //   STATS: '/tournaments/stats',
  //   VENDOR_COURTS: (vendorId) => `/tournaments/vendor/${vendorId}/courts`,
  // },

  // REGISTRATIONS: {
  //   BASE: '/tournaments/registrations',
  //   BY_ID: (id) => `/tournaments/registrations/${id}`,
  //   STATUS: (id) => `/tournaments/registrations/${id}/status`,
  //   APPROVE: (id) => `/tournaments/registrations/${id}/approve`,
  //   REJECT: (id) => `/tournaments/registrations/${id}/reject`,
  // },

  // MATCHES: {
  //   BASE: '/tournaments/matches',
  //   BY_ID: (id) => `/tournaments/matches/${id}`,
  // },

  // VENDOR: {
  //   TOURNAMENTS: {
  //     BASE: '/tournaments/vendor',
  //     BY_ID: (id) => `/tournaments/vendor/${id}`,
  //     TOGGLE: (id) => `/tournaments/vendor/${id}/toggle`,
  //     STATS: '/tournaments/vendor/stats',
  //     MY_COURTS: '/tournaments/vendor/courts',
  //   },

  //   REGISTRATIONS: {
  //     BASE: '/tournaments/vendor/registrations',
  //     BY_ID: (id) => `/tournaments/vendor/registrations/${id}`,
  //     STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
  //   },

  //   MATCHES: {
  //     BASE: '/tournaments/vendor/matches',
  //     BY_ID: (id) => `/tournaments/vendor/matches/${id}`,
  //   },
  // },
    TOURNAMENTS: {
    BASE: '/tournaments',
    BY_ID: (id) => `/tournaments/${id}`,
    TOGGLE: (id) => `/tournaments/${id}/toggle`,
    STATS: '/tournaments/stats',
    VENDOR_COURTS: (vendorId) => `/tournaments/vendors/${vendorId}/courts`,
  },

  REGISTRATIONS: {
    BASE: '/tournaments/registrations',
    BY_ID: (id) => `/tournaments/registrations/${id}`,
    STATUS: (id) => `/tournaments/registrations/${id}/status`,
    APPROVE: (id) => `/tournaments/registrations/${id}/approve`,
    REJECT: (id) => `/tournaments/registrations/${id}/reject`,
  },

  MATCHES: {
    BASE: '/tournaments/matches',
    BY_ID: (id) => `/tournaments/matches/${id}`,
  },

  CUSTOMER: {
    TOURNAMENTS: {
      BASE: '/tournaments/customer',
      BY_ID: (id) => `/tournaments/customer/${id}`,
      TOGGLE: (id) => `/tournaments/customer/${id}/toggle`,
    },

  VENDOR: {
    TOURNAMENTS: {
      BASE: '/tournaments/vendor',
      BY_ID: (id) => `/tournaments/vendor/${id}`,
      TOGGLE: (id) => `/tournaments/vendor/${id}/toggle`,
      STATS: '/tournaments/vendor/stats',
      MY_COURTS: '/tournaments/vendor/courts',
    },

     // NEW
  
  },

    REGISTRATIONS: {
      BASE: '/tournaments/vendor/registrations',
      BY_ID: (id) => `/tournaments/vendor/registrations/${id}`,
      STATUS: (id) => `/tournaments/vendor/registrations/${id}/status`,
    },

    MATCHES: {
      BASE: '/tournaments/vendor/matches',
      BY_ID: (id) => `/tournaments/vendor/matches/${id}`,
    },
  },

    // Coaches
    // COACHES: {
    // LIST: '/coaches',
    // GET: (id) => `/coaches/${id}`,
    // SLOTS: (id) => `/coaches/${id}/slots`,

    // MY_COACHES: '/coaches/my',
    // VENDOR_REGISTRATION: (id) => `/coaches/my/${id}/registration`,
    // CREATE: '/coaches',
    // UPDATE_MY: (id) => `/coaches/my/${id}`,
    // DELETE_MY: (id) => `/coaches/my/${id}`,
    // TOGGLE_STATUS: (id) => `/coaches/my/${id}/status`,

    // ADMIN_ALL: '/coaches/admin/all',
    // ADMIN_VENDORS: '/coaches/admin/vendors',
    // ADMIN_COURTS_BY_VENDOR: (vendorId) => `/coaches/admin/vendors/${vendorId}/courts`,
    // ADMIN_REGISTRATION: (id) => `/coaches/admin/${id}/registration`,
    // ADMIN_UPDATE: (id) => `/coaches/admin/${id}`,
    // ADMIN_TOGGLE_STATUS: (id) => `/coaches/admin/${id}/status`,
    // },
//     COACHES: {
//   // ─── Public ───────────────────────────────────────────────────────────────
//   LIST  : '/coaches',
//   GET   : (id) => `/coaches/${id}`,
//   SLOTS : (id) => `/coaches/${id}/slots`,        

//   // ─── Vendor ───────────────────────────────────────────────────────────────
//   MY_COACHES          : '/coaches/my',
//   VENDOR_REGISTRATION : (id) => `/coaches/my/${id}/registration`,
//   CREATE              : '/coaches',
//   UPDATE_MY           : (id) => `/coaches/my/${id}`,
//   DELETE_MY           : (id) => `/coaches/my/${id}`,
//   TOGGLE_STATUS       : (id) => `/coaches/my/${id}/status`,
//   MY_SLOTS_WEEKLY     : (id) => `/coaches/my/${id}/slots/weekly`,   // ✅ NEW
//   MY_COURTS: '/coaches/my/courts',

//   // ─── Admin ────────────────────────────────────────────────────────────────
//   ADMIN_ALL               : '/coaches/admin/all',
//   ADMIN_VENDORS           : '/coaches/admin/vendors',
//   ADMIN_COURTS_BY_VENDOR  : (vendorId) => `/coaches/admin/vendors/${vendorId}/courts`,
//   ADMIN_REGISTRATION      : (id) => `/coaches/admin/${id}/registration`,
//   ADMIN_UPDATE            : (id) => `/coaches/admin/${id}`,
//   ADMIN_TOGGLE_STATUS     : (id) => `/coaches/admin/${id}/status`,
//   ADMIN_SLOTS_WEEKLY      : (id) => `/coaches/admin/${id}/slots/weekly`, // ✅ NEW
// },
COACHES: {
  LIST: '/coaches',
  GET: (id) => `/coaches/${id}`,
  SLOTS: (id) => `/coaches/public/${id}/slots`,

  MY_COACHES: '/coaches/my',
  VENDOR_REGISTRATION: (id) => `/coaches/my/${id}/registration`,
  CREATE: '/coaches',
  UPDATE_MY: (id) => `/coaches/my/${id}`,
  DELETE_MY: (id) => `/coaches/my/${id}`,
  TOGGLE_STATUS: (id) => `/coaches/my/${id}/status`,
  MY_SLOTS_WEEKLY: (id) => `/coaches/my/${id}/slots/weekly`,
  MY_COURTS: '/coaches/my/courts',

  ADMIN_ALL: '/coaches/admin/all',
  ADMIN_VENDORS: '/coaches/admin/vendors',
  ADMIN_COURTS_BY_VENDOR: (vendorId) => `/coaches/admin/vendors/${vendorId}/courts`,
  ADMIN_REGISTRATION: (id) => `/coaches/admin/${id}/registration`,
  ADMIN_UPDATE: (id) => `/coaches/admin/${id}`,
  ADMIN_TOGGLE_STATUS: (id) => `/coaches/admin/${id}/status`,
  ADMIN_SLOTS_WEEKLY: (id) => `/coaches/admin/${id}/slots/weekly`,
},

    // Courts — Gateway /courts/* → Courts Service
    // COURTS: {
    //     LIST:           '/courts',
    //     CREATE:         '/courts',
    //     UPDATE:         (id) => `/courts/${id}`,
    //     DELETE:         (id) => `/courts/${id}`,
    //     REGISTRATIONS:  (id) => `/courts/${id}/registrations`,
    //     GENERATE_SLOTS: (id) => `/courts/${id}/generate-slots`,
    // },
    // COURTS: {
    // LIST:           '/courts',
    // GET_BY_ID:      (id) => `/courts/${id}`,
    // MY_COURTS:      '/courts/my',
    // CREATE:         '/courts',
    // UPDATE:         (id) => `/courts/my/${id}`,
    // DELETE:         (id) => `/courts/my/${id}`,
    // TOGGLE_STATUS:  (id) => `/courts/my/${id}/status`,
    // ADMIN_STATUS:   (id) => `/courts/${id}/status`,
    // REGISTRATIONS:  (id) => `/courts/${id}/registrations`,
    // },
//     COURTS: {
//     // ── Public ──────────────────────────────────────────────────────────────
//     LIST:             '/courts',
//     GET_BY_ID:        (id) => `/courts/${id}`,

//     // ── Vendor / Admin ───────────────────────────────────────────────────────
//     MY_COURTS:        '/courts/my',
//     CREATE:           '/courts',
//     UPDATE:           (id) => `/courts/my/${id}`,
//     DELETE:           (id) => `/courts/my/${id}`,
//     TOGGLE_STATUS:    (id) => `/courts/my/${id}/status`,
//     REGISTRATIONS:    (id) => `/courts/${id}/registrations`,

//     // ── Admin Override ───────────────────────────────────────────────────────
//     ADMIN_STATUS:     (id) => `/courts/${id}/status`,

//     // ── Slots (Separate CourtSlot collection) ────────────────────────────────
//     SLOTS_WEEKLY:     (id) => `/courts/${id}/slots/weekly`,
//     BOOK_SLOT:        (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/book`,
//     UNBOOK_SLOT:      (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/unbook`,

//     // ── Dropdowns ────────────────────────────────────────────────────────────
//     DROPDOWN_SPORTS:  '/courts/dropdown/sports',
//     DROPDOWN_VENDORS: '/courts/dropdown/vendors',
// },
COURTS: {
    LIST: '/courts',
    GET_BY_ID: (id) => `/courts/${id}`,

    MY_COURTS: '/courts/my',
    CREATE: '/courts',
    UPDATE: (id) => `/courts/my/${id}`,
    DELETE: (id) => `/courts/my/${id}`,
    TOGGLE_STATUS: (id) => `/courts/my/${id}/status`,
    REGISTRATIONS: (id) => `/courts/${id}/registrations`,

    ADMIN_STATUS: (id) => `/courts/${id}/status`,

    SLOTS_PUBLIC: (id) => `/courts/${id}/slots/public`,
    SLOTS_WEEKLY: (id) => `/courts/${id}/slots/weekly`,
    BOOK_SLOT: (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/book`,
    UNBOOK_SLOT: (id, day, slotId) => `/courts/${id}/slots/${day}/${slotId}/unbook`,

    DROPDOWN_SPORTS: '/courts/dropdown/sports',
    DROPDOWN_VENDORS: '/courts/dropdown/vendors',
  },
  //  PLAYERS: {
  // // Public
  //   LIST: '/players',
  //   GET: (id) => `/players/${id}`,
  //   SLOTS: (id) => `/players/${id}/slots`,

  //   // Vendor
  //   MY_PLAYERS: '/players/my',
  //   VENDOR_REGISTRATION: (id) => `/players/my/${id}/registration`,
  //   CREATE: '/players',
  //   UPDATE_MY: (id) => `/players/my/${id}`,
  //   DELETE_MY: (id) => `/players/my/${id}`,
  //   TOGGLE_MY_STATUS: (id) => `/players/my/${id}/status`,
  //   MY_SLOTS_WEEKLY: (id) => `/players/my/${id}/slots/weekly`,
  //   MY_COURTS: '/players/my/courts',

  //   // Slot booking
  //   BOOK_SLOT: (playerId, day, slotId) =>
  //       `/players/${playerId}/slots/${day}/${slotId}/book`,
  //   UNBOOK_SLOT: (playerId, day, slotId) =>
  //       `/players/${playerId}/slots/${day}/${slotId}/unbook`,

  //   // Admin
  //   ADMIN_ALL: '/players/admin/all',
  //   ADMIN_VENDORS: '/players/admin/vendors',
  //   ADMIN_COURTS_BY_VENDOR: (vendorId) =>
  //       `/players/admin/vendors/${vendorId}/courts`,
  //   ADMIN_REGISTRATION: (id) => `/players/admin/${id}/registration`,
  //   ADMIN_TOGGLE_STATUS: (id) => `/players/admin/${id}/status`,
  //   ADMIN_UPDATE: (id) => `/players/admin/${id}`,
  //   ADMIN_DELETE: (id) => `/players/admin/${id}`,
  //   ADMIN_SLOTS_WEEKLY: (id) => `/players/admin/${id}/slots/weekly`,
  //   },
    PLAYERS: {
  LIST: '/players',
  GET: (id) => `/players/${id}`,
  SLOTS: (id) => `/players/${id}/slots`,

  CREATE: '/players',

  MY_PLAYERS: '/players/my',
  VENDOR_REGISTRATION: (id) => `/players/my/${id}/registration`,
  VENDOR_UPDATE: (id) => `/players/my/${id}`,
  VENDOR_STATUS: (id) => `/players/my/${id}/status`,
  VENDOR_DELETE: (id) => `/players/my/${id}`,
  VENDOR_WEEKLY_SLOTS: (id) => `/players/my/${id}/slots/weekly`,
  MY_COURTS: '/players/my/courts',

  ADMIN_ALL: '/players/admin/all',
  ADMIN_REGISTRATION: (id) => `/players/admin/${id}/registration`,
  ADMIN_UPDATE: (id) => `/players/admin/${id}`,
  ADMIN_STATUS: (id) => `/players/admin/${id}/status`,
  ADMIN_DELETE: (id) => `/players/admin/${id}`,
  ADMIN_WEEKLY_SLOTS: (id) => `/players/admin/${id}/slots/weekly`,
  ADMIN_VENDORS: '/players/admin/vendors',
  ADMIN_COURTS_BY_VENDOR: (vendorId) => `/players/admin/vendors/${vendorId}/courts`,

  BOOK_SLOT: (id, day, slotId) => `/players/${id}/slots/${day}/${slotId}/book`,
  UNBOOK_SLOT: (id, day, slotId) => `/players/${id}/slots/${day}/${slotId}/unbook`,
},

    // Users
    USERS: {
        LIST:          '/users',
        GET_BY_ID:     (id) => `/users/${id}`,
        UPDATE_STATUS: (id) => `/users/${id}/status`,
        STATS:         '/users/stats',
    },

    
    SPORTS: {
    LIST:          '/sports',
    LIST_ALL:      '/sports/all',
    CREATE:        '/sports',
    GET_BY_ID:     (id) => `/sports/${id}`,
    UPDATE:        (id) => `/sports/${id}`,
    DELETE:        (id) => `/sports/${id}`,
    TOGGLE_STATUS: (id) => `/sports/${id}/status`,   // ← add this
},

    // Payments
    PAYMENTS: {
        LIST:             '/payments',
        STATS:            '/payments/stats',
        REFUND:           (id) => `/payments/${id}/refund`,
        REVENUE_BY_ADMIN: '/payments/revenue-by-admin',
    },

    // Referees
    // REFEREE: {
    //     BASE: '/referees',
    //     BY_ID: (id) => `/referees/${id}`,
    //     STATUS: (id) => `/referees/${id}/status`,
    //     MATCHES: (id) => `/referees/${id}/matches`,
    //     SPORTS: '/referees/sports',
    //     TOURNAMENTS: '/referees/tournaments',
    // },
    REFEREE: {
    BASE: '/referees',
    BY_ID: (id) => `/referees/${id}`,
    STATUS: (id) => `/referees/${id}/status`,
    MATCHES: (id) => `/referees/${id}/assigned-matches`,
    SPORTS: '/referees/sports/active',
    TOURNAMENTS_ASSIGNABLE: '/referees/tournaments/assignable',
  },

    // Roles & Permissions
    ROLES: {
        LIST:               '/roles',
        UPDATE_PERMISSIONS: (roleId) => `/roles/${roleId}/permissions`,
    },
    COMMISSION: {
        GET_ALL: '/commissions',
        UPDATE_SINGLE: '/commissions/single',
        UPDATE_BULK: '/commissions/bulk',
        RESET_DEFAULTS: '/commissions/reset-defaults',
    },
    REWARDS: {
    COUPONS: '/rewards/coupons',
    COUPON_BY_ID: (id) => `/rewards/coupons/${id}`,
    COUPON_TOGGLE: (id) => `/rewards/coupons/${id}/toggle`,
    COUPON_STATS: '/rewards/stats/coupons',

    REDEEM_OPTIONS: '/rewards/redeem-options',
    REDEEM_OPTION_BY_ID: (id) => `/rewards/redeem-options/${id}`,
    REDEEM_OPTION_TOGGLE: (id) => `/rewards/redeem-options/${id}/toggle`,
    REDEEM_STATS: '/rewards/stats/redeem-options',

    POINTS_HISTORY: '/rewards/points-history',
    POINTS_STATS: '/rewards/stats/points',
  },
  // AI_COACH: {
  //   PLANS: '/ai-coach',
  //   PLAN_BY_ID: (id) => `/ai-coach/${id}`,
  //   PLAN_TOGGLE: (id) => `/ai-coach/${id}/toggle`,
  //   PLAN_STATS: '/ai-coach/stats/overview',

  //   ORDERS: '/ai-coach',
  //   ORDER_BY_ID: (id) => `/ai-coach/${id}`,
  //   ORDER_SUBSCRIBERS_BY_PLAN: (planId) => `/ai-coach/${planId}/subscribers`,
  // },
  AI_COACH: {
  PLANS: '/ai-coach/plans',
  PLAN_BY_ID: (id) => `/ai-coach/plans/${id}`,
  PLAN_TOGGLE: (id) => `/ai-coach/plans/${id}/toggle`,
  PLAN_STATS: '/ai-coach/plans/stats/overview',

  ORDERS: '/ai-coach/orders',
  ORDER_BY_ID: (id) => `/ai-coach/orders/${id}`,
  MY_ORDERS: '/ai-coach/orders/me',
  BUY_PLAN: '/ai-coach/orders/buy',
  ORDER_SUBSCRIBERS_BY_PLAN: (planId) => `/ai-coach/orders/plan/${planId}/subscribers`,
},
  ROLES: {
        GET_ALL:          '/roles/roles',            // GET    /roles/roles
        GET_ACTIVE:       '/roles/roles/active',     // GET    /roles/roles/active
        GET_BY_ID:        (id) => `/roles/roles/${id}`,          // GET    /roles/roles/:id
        CREATE:           '/roles/roles',            // POST   /roles/roles
        UPDATE:           (id) => `/roles/roles/${id}`,          // PATCH  /roles/roles/:id
        DELETE:           (id) => `/roles/roles/${id}`,          // DELETE /roles/roles/:id

        GET_PERMISSIONS:  (id) => `/roles/roles/${id}/permissions`,  // GET /roles/roles/:id/permissions
        SAVE_PERMISSIONS: (id) => `/roles/roles/${id}/permissions`,  // PUT /roles/roles/:id/permissions
    },

    PERMISSIONS: {
        MODULES:          '/roles/permissions/modules',  // GET /roles/permissions/modules
    },

    USERS: {
        GET_ALL:          '/roles/users',                // GET    /roles/users
        GET_BY_ID:        (id) => `/roles/users/${id}`,              // GET    /roles/users/:id
        CREATE:           '/roles/users',                // POST   /roles/users (form-data)
        UPDATE:           (id) => `/roles/users/${id}`,              // PATCH  /roles/users/:id
        CHANGE_PASSWORD:  (id) => `/roles/users/${id}/password`,     // PATCH  /roles/users/:id/password
        DELETE_PHOTO:     (id) => `/roles/users/${id}/photo`,        // DELETE /roles/users/:id/photo
        DELETE:           (id) => `/roles/users/${id}`,              // DELETE /roles/users/:id
    },
    // FEEDBACKS: {
    //   // Customer
    //   SUBMIT:         (type)           => `/feedbacks/feedbacks/${type}`,

    //   // Vendor — my feedbacks (JWT-scoped, no vendorId needed in URL)
    //   MY_FEEDBACKS:   (type)           => `/feedbacks/feedbacks/${type}/vendor/my`,

    //   // Vendor / Admin — feedbacks for a specific entity
    //   BY_ENTITY:      (type, entityId) => `/feedbacks/feedbacks/${type}/entity/${entityId}`,

    //   // Admin — feedbacks for a specific vendorId
    //   BY_VENDOR:      (type, vendorId) => `/feedbacks/feedbacks/${type}/vendor/${vendorId}`,

    //   // Admin — all feedbacks across all 4 types
    //   ADMIN_ALL:      '/feedbacks/admin/all',

    //   // Admin — stats
    //   ADMIN_STATS:    '/feedbacks/admin/stats',

    //   // Vendor / Admin — delete a feedback
    //   DELETE:         (type, id)       => `/feedbacks/feedbacks/${type}/${id}`,
    // },
    FEEDBACKS: {
      SUBMIT:         (type)           => `/feedbacks/feedbacks/${type}`,
      MY_FEEDBACKS:   (type)           => `/feedbacks/feedbacks/${type}/vendor/my`,
      BY_ENTITY:      (type, entityId) => `/feedbacks/feedbacks/${type}/entity/${entityId}`,
      BY_VENDOR:      (type, vendorId) => `/feedbacks/feedbacks/${type}/vendor/${vendorId}`,
      PUBLIC_SUMMARY: (type, entityId) => `/feedbacks/feedbacks/public/${type}/entity/${entityId}/summary`,
      ADMIN_ALL:      '/feedbacks/admin/all',
      ADMIN_STATS:    '/feedbacks/admin/stats',
      DELETE:         (type, id)       => `/feedbacks/feedbacks/${type}/${id}`,
    },
    // BOOKINGS: {

    //   // ─── POST ─────────────────────────────────────────────────────────────────
    //   CREATE_COURT  : '/bookings/court',
    //   CREATE_COACH  : '/bookings/coach',
    //   CREATE_PLAYER : '/bookings/player',

    //   // ─── GET /bookings/:bookingId ─────────────────────────────────────────────
    //   GET: (bookingId) => `/bookings/${bookingId}`,

    //   // ─── GET /bookings/vendor/:vendorId  (?type=court|coach|player) ──────────
    //   BY_VENDOR: (vendorId) => `/bookings/vendor/${vendorId}`,

    //   // ─── GET /bookings/entity/:type/:entityId ─────────────────────────────────
    //   BY_ENTITY: (type, entityId) => `/bookings/entity/${type}/${entityId}`,

    //   // ─── PATCH /bookings/:bookingId/cancel ────────────────────────────────────
    //   CANCEL: (bookingId) => `/bookings/${bookingId}/cancel`,
    // },
    BOOKINGS: {
        CREATE_COURT: '/bookings/court',
        CREATE_COACH: '/bookings/coach',
        CREATE_PLAYER: '/bookings/player',

        GET: (bookingId) => `/bookings/${bookingId}`,

        MY_BOOKINGS: '/bookings/my-bookings',
        CUSTOMER_MY_BOOKINGS: '/bookings/customer/my-bookings',

        BY_VENDOR: (vendorId) => `/bookings/vendor/${vendorId}`,

        BY_ENTITY: (type, entityId) => `/bookings/entity/${type}/${entityId}`,

        CANCEL: (bookingId) => `/bookings/${bookingId}/cancel`,
      },
    // TOURNAMENT_REGISTRATIONS: {
    //   CREATE: '/tournamentregistrations/',
    //   MY_REGISTRATIONS: '/tournamentregistrations/me',
    //   GET: (registrationId) => `/tournamentregistrations/${registrationId}`,
    //   BY_TOURNAMENT: (tournamentId) => `/tournamentregistrations/tournament/${tournamentId}`,
    //   CANCEL: (registrationId) => `/tournamentregistrations/${registrationId}/cancel`,
    // },
    TOURNAMENT_REGISTRATIONS: {
      CREATE: '/tournamentregistrations/',
      MY_REGISTRATIONS: '/tournamentregistrations/me',
      GET: (registrationId) => `/tournamentregistrations/${registrationId}`,
      BY_TOURNAMENT: (tournamentId) => `/tournamentregistrations/tournament/${tournamentId}`,
      CANCEL: (registrationId) => `/tournamentregistrations/${registrationId}/cancel`,
      APPROVE: (registrationId) => `/tournamentregistrations/${registrationId}/approve`,
      REJECT: (registrationId) => `/tournamentregistrations/${registrationId}/reject`,
    },
  //   MONTHLY_PLAN_BOOKINGS: {
  //   CREATE: '/monthly-bookings/monthly-plan-bookings',
  //   MY_BOOKINGS: '/monthly-bookings/monthly-plan-bookings/me',
  //   GET: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}`,
  //   CANCEL: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}/cancel`,
  //   ADMIN_LIST: '/monthly-bookings/monthly-plan-bookings',
  // },
  MONTHLY_PLAN_BOOKINGS: {
    CREATE: '/monthly-bookings/monthly-plan-bookings',
    MY_BOOKINGS: '/monthly-bookings/monthly-plan-bookings/me',
    GET: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}`,
    CANCEL: (bookingId) => `/monthly-bookings/monthly-plan-bookings/${bookingId}/cancel`,
    ADMIN_LIST: '/monthly-bookings/monthly-plan-bookings',
  },
  PERFORMANCE_REVIEWS: {
    CREATE: '/performance-reviews',
    GET_BY_ID: (reviewId) => `/performance-reviews/${reviewId}`,
    GET_BY_BOOKING: (bookingId) => `/performance-reviews/booking/${bookingId}`,
    GET_BY_COACH: (coachId) => `/performance-reviews/coach/${coachId}`,
    GET_BY_STUDENT: (studentId) => `/performance-reviews/student/${studentId}`,
    UPDATE: (reviewId) => `/performance-reviews/${reviewId}`,
    DELETE: (reviewId) => `/performance-reviews/${reviewId}`,
  },
  MEMBERSHIPS: {
    BUY: '/memberships/buy',
    MY: '/memberships/my',
    GET_ONE: (id) => `/memberships/${id}`,

    ADMIN_ALL: '/memberships/admin/all',

    VENDOR_ALL: '/memberships/vendor/all',
  },
};